export default {
  abastecimentosAgua: {
    REDE_PUBLICA: 'Rede pública',
    POCO: 'Poço',
    NASCENTE_RIO_IGARAPE: 'Nascente/Rio/Igarapé',
    CAIXA_DAGUA: 'Caixa D’água',
    RIO_LAGO_MAR: 'Rio, lago ou mar',
    NAO_POSSUI: 'Não Possui'
  },

  aquisicao: {
    POSSEIRO: 'Posseiro',
    COMPRA_E_VENDA: 'Compra e venda',
    DOACAO: 'Doação',
    OUTROS: 'Outros'
  },

  possuiAnexo: {
    SIM: 'Sim',
    NAO: 'Não'
  },

  arborizacao: {
    ZERO: '0',
    ENTRE_1_E_3: 'Entre 1 e 3',
    ENTRE_3_E_6: 'Entre 3 e 6',
    MAIS_QUE_6: 'Mais que 6'
  },

  calcadaExterna: {
    POSSUI: 'Possui',
    NAO_POSSUI: 'Não possui'
  },

  coberturas: {
    CERAMICA: 'Cerâmica',
    FIBROCIMENTO_BRASILIT: 'Fibrocimento/Brasilit',
    FIBROCIMENTO_ZINCO: 'Fibrocimento/Zinco',
    ZINCO: 'Zinco',
    CONCRETO_LAJE: 'Concreto (laje)',
    PALHA_CAVACO: 'Palha/Cavaco',
    IMPROVISADO: 'Improvisado',
    OUTROS: 'Outros',
    NAO_SE_APLICA: 'Não se aplica'
  },

  conservacao: {
    PRECARIO: 'Precário (Péssimo)',
    REGULAR: 'Regular',
    BOA: 'Boa',
    NOVA: 'Nova (ótima)'
  },

  delimitacao: {
    CERCA: 'Cerca',
    MURO: 'Muro',
    IMPROVISADA: 'Improvisada',
    NAO_POSSUI: 'Não possui'
  },

  delimitacoes: {
    CERCA: 'Cerca',
    MURO: 'Muro',
    IMPROVISADA: 'Improvisada',
    NAO_POSSUI: 'Não possui'
  },

  destinacaoLixos: {
    COLETADO_SERVICO_PUBLICO: 'Coletado (serviço público)',
    QUEIMADO: 'Queimado',
    ENTERRADO: 'Enterrado',
    TERRENO_BALDIO: 'Terreno baldio',
    RIO_LAGO_MAR: 'Rio, lago ou mar'
  },

  disposicao: {
    ISOLADA: 'Isolada',
    CONJUGADA: 'Conjugada',
    GERMINADA: 'Germinada'
  },

  dominilidade: {
    PARTICULAR: 'Particular',
    FEDERAL: 'Federal',
    ESTADUAL: 'Estadual',
    MUNICIPAL: 'Municipal'
  },

  estadoImovel: {
    PERMANENTE: 'Permanente',
    TEMPORARIO: 'Temporário',
    DESOCUPADO: 'Desocupado',
    ABANDONADO: 'Abandonado',
    OUTROS: 'Outros'
  },

  estruturas: {
    MADEIRA: 'Madeira',
    ADVENTO: 'Advento',
    ALVENARIA: 'Alvenaria',
    METALICA: 'Metálica',
    CONCRETO: 'Concreto',
    MISTO: 'Misto',
    OUTROS: 'Outros',
    NAO_SE_APLICA: 'Não se aplica'
  },

  finalidade: {
    ABERTURA_MATRICULA: 'Abertura de matrícula',
    FINANCIAMENTO_BANCARIO: 'Financiamento bancário',
    LICENCIAMENTO_AMBIENTAL: 'Licenciamento ambiental',
    MANEJO_FLORESTAL: 'Manejo florestal',
    REQUALIFICACAO_DESBLOQUEIO: 'Requalificação/Desbloqueio',
    OUTROS: 'Outros'
  },

  fornecimentoEnergia: {
    NAO_POSSUI: 'Não possui',
    IMPROVISANDO_IRREGULAR: 'Improvisado irregular',
    REGULAR_SEM_MEDIDOR: 'Regular sem medidor',
    REGULAR_COM_MEDIDOR: 'Regular com medidor',
    ENERGIA: 'Energia',
    ENERGIA_SOLAR: 'Energia solar'
  },

  forros: {
    NAO_POSSUI: 'Não possui',
    PVC: 'PVC',
    GESSO: 'Gesso',
    MADEIRA: 'Madeira',
    OUTROS: 'Outros'
  },

  funcao: {
    SOCIO: 'Socio',
    REPRESENTANTE: 'Representante',
    GEOMENSOR: 'Geomensor',
    FISCALIZADOR: 'Fiscalizador',
    VISTORIADOR: 'Vistoriador',
    LEVANTAMENTO_SOCIO_ECONOMICO: 'Levantamento socioeconômico',
    ADMINISTRATIVO: 'Administrativo',
    OUTROS: 'Outros'
  },

  implantacao: {
    ALINHADA: 'Alinhada',
    RECUADA: 'Recuada',
    ULTRAPASSA_LIMITE: 'Ultrapassa o limite'
  },

  instalacaoEletrica: {
    APARENTE: 'Aparente',
    EMBUTIDO: 'Embutido',
    MISTA: 'Mista',
    GESSO: 'Gesso',
    MADEIRA: 'Madeira'
  },

  localizacao: {
    MEIO_QUADRA: 'Meio de quadra',
    ESQUINA_01_FRENTE: 'Esquina de 01 frente',
    VIA: 'Via',
    ENCRAVADO_SEM_ACESSO_VIA: 'Encravado s/acesso via',
    OUTROS: 'Outros'
  },

  localizacaoSanitario: {
    INTERNO: 'Interno',
    EXTERNO: 'Externo'
  },

  localizacoesSanitarios: {
    INTERNO: 'Interno',
    EXTERNO: 'Externo'
  },

  ocupacao: {
    EM_CONSTRUCAO: 'Em construção',
    CONSTRUIDO: 'Construído',
    NAO_CONSTRUIDO_VAZIO: 'Não construído (vazio)',
    CONSTRUCAO_PARALISADA: 'Construção paralisada',
    RUINAS_DEMOLICAO: 'Ruínas (demolição)',
    TERRENO: 'Terreno'
  },

  padraoConstrutivo: {
    SIMPLES_POPULAR: 'Simples popular',
    MEDIO: 'Médio',
    ESPECIAL_LUXO: 'Especial luxo',
    ADAPTADO_IMPROVISADO: 'Adaptado/Improvisado'
  },

  paredes: {
    MADEIRA: 'Madeira',
    ALVENARIA: 'Alvenaria',
    MISTO: 'Misto',
    TAIPA: 'Taipa',
    IMPROVISADO: 'Improvisado',
    OUTROS: 'Outros'
  },

  possuiPiscina: {
    SIM: 'Sim',
    NAO: 'Não'
  },

  pisos: {
    CHAO_BATIDO: 'Chão batido',
    CIMENTO: 'Cimento',
    CERAMICA: 'Cerâmica',
    TABUA_TACO: 'Tábua/Taco',
    OUTROS: 'Outros'
  },

  possuiAlvara: {
    SIM: 'Sim',
    NAO: 'Não'
  },

  possuiReservaLegal: {
    SIM: 'Sim',
    NAO: 'Não',
    NAO_SABE: 'Não Sabe'
  },

  quintalAreaLivre: {
    SIM: 'Sim',
    NAO: 'Não'
  },

  regimeUso: {
    PROPRIO: 'Próprio (comprado 3º)',
    CEDIDO: 'Cedido',
    ALUGADO: 'Alugado',
    OCUPADO: 'Ocupado',
    OUTROS: 'Outros'
  },

  regimeUsos: {
    PROPRIO: 'Próprio',
    CEDIDO: 'Cedido',
    ALUGADO: 'Alugado',
    OCUPADO: 'Ocupado',
    OUTROS: 'Outros'
  },

  renda: {
    NENHUMA: 'Nenhuma',
    DE_1_ATE_3: '1 a 3 salários mínimos',
    DE_4_ATE_5: '4 a 5 salários mínimos',
    SUPERIOR_A_5: 'Mais que 5 salários mínimos'
  },

  revestimentos: {
    SEM_TIJOLO_APARENTE: 'Sem tijolo aparente',
    NAO_POSSUI_REVESTIMENTO: 'Não possui revestimento',
    CHAPISCO: 'Chapisco',
    REBOCO_EMBOCO: 'Reboco/Emboço',
    MADEIRA: 'Madeira',
    CERAMICO: 'Cerâmico',
    OUTROS: 'Outros'
  },

  sistemaSanitario: {
    REDE_PUBLICA: 'Rede pública',
    FOSSA_SEPTICA: 'Fossa séptica',
    FOSSA_RUDIMENTAR: 'Fossa rudimentar',
    VALA_CEU_ABERTO: 'Vala céu aberto',
    RIO_LAGO_MAR: 'Rio, lago ou mar'
  },

  situacao: {
    NORMAL_FIRME: 'Normal Firme',
    ALAGAVEL: 'Alagável',
    ALAGADO: 'Alagado',
    FRENTE: 'Frente',
    SECUNDARIA: 'Fundos'
  },

  tipologia: {
    CONSTRUCAO_TERREA: 'Construção térrea',
    MAIS_DE_1_PAVILHAO: 'Mais de 1 pavilhão',
    MAIS_DE_1_PAVIMENTO: 'Mais de 1 pavimento',
    CONSTRUCAO_ANEXA: 'Construção anexa',
    GALPAO: 'Galpão',
    OUTROS: 'Outros'
  },

  tipoLogradouro: {
    RUA: 'Rua',
    RAMAL: 'Ramal',
    PASSAGEM: 'Passagem',
    PRACA: 'Praça',
    ALAMEDA: 'Alameda',
    TRAVESSA: 'Travessa',
    AVENIDA: 'Avenida'
  },

  tipoModalidade: {
    CARTA_SESMARIAS: 'Carta de Sesmarias',
    POSSE: 'Posse',
    TITULO_DEFINITIVO_DOACAO:
      'Título definitivo de doação sob condições resolutivas (Não Onerosa)',
    TITULO_DEFINITIVO_LOTE: 'Título definitivo de lote colonial',
    TITULO_LEGITIMACAO: 'Título de legitimação de posse',
    TITULO_PROPRIEDADE:
      'Título de propriedade sob condições resolutivas (Onerosa)',
    OUTROS: 'Outros'
  },

  tipoUnidade: {
    PRINCIPAL: 'Principal',
    SECUNDARIA: 'Secundária'
  },

  topografia: {
    PLANA: 'Plana',
    ACIDENTADA: 'Acidentada'
  },

  usoSolos: {
    SEM_USO: 'Sem uso',
    HABITACIONAL: 'Habitacional',
    RESIDENCIAL: 'Residencial',
    COMERCIAL_SERVICO: 'Comercial/serviço',
    INDUSTRIAL: 'Industrial',
    EDUCACAO_CULTURA: 'Educação/cultura',
    ESPORTE_LAZER: 'Esporte/Lazer',
    RELIGIOSO: 'Religioso',
    ASSOCIATIVO_COMUNITARIO: 'Associativo/Comunitário',
    MISTO: 'Uso misto (comercial e residencial)',
    OUTROS: 'Outros',
    TERRENO: 'Terreno'
  },

  utilizacaoSanitario: {
    PARTICULAR: 'Particular',
    COLETIVO: 'Coletivo'
  },

  utilizacoesSanitarios: {
    PARTICULAR: 'Particular',
    COLETIVO: 'Coletivo'
  },

  tipologiaPoco: {
    ARTESIANO: 'Artesiano',
    AMAZONAS: 'Amazonas'
  }
}



// WEBPACK FOOTER //
// ./src/utils/enumDadosImovelMobile.js